import { Injectable, inject } from '@angular/core';

import { ApContentService } from '@ap/content';
import { FilesValidator, NotificationMetadata, ReadFile, ApFileSelectorComponent, ApBytesPipe } from '@ap/file';

@Injectable()
export class ApCombinedSizeValidator implements FilesValidator {
    private readonly contentService = inject(ApContentService);
    private readonly apBytes = inject(ApBytesPipe);

    public fileSelector: ApFileSelectorComponent;

    public showNotification = false;
    public multipleAdded = false;

    public getNotification(): NotificationMetadata {
        const key = this.multipleAdded ? 'file-upload.warning.fileSize.combined.multiple' : 'file-upload.warning.fileSize.combined';
        const sizeLimit = this.apBytes.transform(this.fileSelector.fileSizeLimitInMB() * 1024 * 1024);
        return {
            type: 'error',
            content: this.contentService.get(key, { sizeLimit })
        };
    }

    public validate(previousValue: ReadFile[], currentValue: ReadFile[]): boolean {
        const totalFileSize = currentValue.reduce((total, readFile) => total + readFile.size, 0);
        const allFilesWithinLimit = currentValue.every((file) => file.size < this.fileSelector.fileSizeLimitInMB() * 1024 * 1024);
        const isValid = totalFileSize < this.fileSelector.fileSizeLimitInMB() * 1024 * 1024 && allFilesWithinLimit;
        this.showNotification = !isValid && allFilesWithinLimit;
        this.multipleAdded = currentValue.length - previousValue.length > 1;
        return isValid;
    }
}
